import React from 'react';
import compose from '../../hoc/compose';
import PropTypes from 'prop-types';

var Divider = function Divider(props) {
  var newProps = {
    className: props.getClassName(props["long"] ? 'divider-long' : 'divider-short'),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  };
  return /*#__PURE__*/React.createElement('hr', newProps);
};

Divider.displayName = 'Divider';
Divider.propTypes = {
  /** Makes the divider coast to coast */
  "long": PropTypes.bool
};
Divider.defaultProps = {
  "long": false
};
export default compose(Divider);